{
  "fr": {
    "marketplace_partner": {
      "contact_me": {
        "success": "Nous vous contacterons bientôt.",
        "failure": "Une erreur inattendue s'est produite.",
        "button": "Contactez moi!"
      }
    }
  }
}
